<script lang="ts">
  import type { SvelteComponentDev } from "svelte/internal"

  export let active: boolean | undefined = undefined
  export let disabled: boolean | undefined = undefined
  export let icon: SvelteComponentDev | undefined = undefined

  $: iconStatusClasses = [
    active ? "active" : "",
    disabled ? "disabled" : "",
  ].join(" ")
</script>

<button
  class={$$props.class}
  class:active
  disabled={disabled}
  on:click
>
  {#if icon}
    <svelte:component
      this={icon}
      class="{iconStatusClasses} button-icon"
    />
  {/if}
  <slot></slot>
</button>

<style lang="scss">
  button {
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
